import zPage from '../Page/page.vue';
import comLeaveWord from '../../components/com-leave-word.vue';
import comList from '../../components/com-list.vue';
import comRichtext from '@/components/com-richtext.vue';
import {removeRichTextLabel,hiddenPhone} from '@/assets/js/tools.js';
export default{
    name:'Procurement',
    data(){
        return{
            currentColumn:'招采中心',
            columnType:1,//1列表2详情
            imgs:[
            ],
            qxImgs:[],
            page:{
                targetPage:1,
                pageSize:10,
                totalPage:0,
                type:1,
            },
            procureList:[],
            BIDtype:'BID',
            bidList:[],
            typeTop: [], // 4个类型列表
            typeAll: [], // 所有列表
            typeCode:'',
            deviceList:[],
            zcType:'BID',
            zcList:[],
            qxList:[],
            qxDetail:{},
            bidDetail:{},
            chatId:'',
            source:'QCZS',
            deviceTypeCode:'',
            cgWord:'',
        }
    },
    components:{
        zPage,
        comLeaveWord,
        comList,
        comRichtext,
    },
    created(){
        this.getNewPageZcxxTop7();
        this.getPageZcxxBIDTop5();
        this.getTypeAll();
        
    },
    methods:{
        changeColumn(name){
            this.columnType=1;
            this.zcType='BID',
            this.currentColumn=name;
            this.page={
                targetPage:1,
                pageSize:10,
                totalPage:0,
                type:2,
            };
            if(name=='招标中标'){
                this.pageZczxPage();
            }
            if(name=='器械招商'){
                this.getQxzsPage();
            }
            if(name=='采购信息'){
                this.zcType='PURCHASE';
                this.pageZczxPage();
            }
            
        },
        goToDetail(){
            this.columnType=2;

        },
        getNewPageZcxxTop7(){
            this.get(this.api.getNewPageZcxxTop7).then(res=>{
                if(res.result==200){
                    this.procureList=res.data;
                    for(var i=0;i<this.procureList.length;i++){
                        this.procureList[i].createDate=this.procureList[i].createDate.substring(0,10);
                        this.imgs.push({path:this.procureList[i].images,title:this.procureList[i].titleName,procure:this.procureList[i]});
                    }
                }
            }).catch();
        },
        getPageZcxxBIDTop5(){
            var body={
                zcType:this.BIDtype,
            };
            this.get(this.api.getPageZcxxBIDTop5,body).then(res=>{
                if(res.result==200){
                    this.bidList=res.data;
                }
            }).catch();
        },
        getNewPageZcxx3(){
            var body={deviceTypeCode:this.typeCode };
            this.get(this.api.getNewPageZcxx3,body).then(res=>{
                if(res.result==200){
                    this.deviceList=res.data;
                    for(var i=0;i<this.deviceList.length;i++){
                        this.deviceList[i].abstract=removeRichTextLabel(this.deviceList[i].content);
                        this.deviceList[i].createDate=this.deviceList[i].createDate.substring(0,10);
                    }
                }
            }).catch();
        },
        // 获取所有类型
        getTypeAll () {
            this.get(this.api.getQXZSDeviceType).then(res => {
                if (res.result == 200) {
                    
                    this.typeAll = res.data;
                    this.typeTop=this.typeAll.slice(0,4);
                    this.typeCode = this.typeTop[0].code;
                    this.getNewPageZcxx3();
                }
            })
        },
        setTypeCode (code) {
            this.typeCode = code;
            this.getNewPageZcxx3();
        },

        handleCommand (command) {
            this.setTypeCode(command);
        },
        changeBID(type){
            this.BIDtype=type;
            this.getPageZcxxBIDTop5();
        },
        changeBIDCenter(type){
            this.zcType=type;
            this.page={
                targetPage:1,
                pageSize:10,
                totalPage:0,
                type:2,
            };
            this.pageZczxPage();
            
        },
        pageZczxPage(){
            var body={
                pageNumber:this.page.targetPage-1,
                pageSize:this.page.pageSize,
                zcType:this.zcType,
                word:this.cgWord,
            };
            this.get(this.api.pageZczxPage,body).then(res=>{
                if(res.result==200){
                    this.zcList=res.data.list;
                    this.page.totalPage=res.data.totalElements;
                    for(var i=0;i<this.zcList.length;i++){
                        this.zcList[i].infoTitle=this.zcList[i].titleName;
                        this.zcList[i].createDate=this.zcList[i].createDate.substring(0,10);
                    }
                }
            }).catch();
        },
        getQxzsPage(){
            this.qxImgs=[];
            var body={
                pageNumber:this.page.targetPage-1,
                pageSize:this.page.pageSize,
                deviceTypeCode:this.deviceTypeCode,
            };
            this.get(this.api.getQxzsPage,body).then(res=>{
                if(res.result==200){
                    this.qxList=res.data.list;
                    this.page.totalPage=res.data.totalElements;
                    for(var i =0; i <this.qxList.length;i++){
                        this.qxImgs.push({path:this.qxList[i].images,title:this.qxList[i].titleName,id:this.qxList[i].id,zcType:this.qxList[i].zcType});
                        this.qxList[i].abstract=removeRichTextLabel(this.qxList[i].content);
                        this.qxList[i].lxrPhone=hiddenPhone(this.qxList[i].lxrPhone);
                    }
                }
            }).catch();
        },
        getQXdetail(id){
            this.currentColumn='器械招商';
            this.chatId=id;
            this.columnType=2;
            this.get(this.api.getQxzsDetail,{id:id}).then(res=>{
                if(res.result==200){
                    
                    this.qxDetail=res.data;
                }
            }).catch();
        },
        getCGDetail(type,item){
            this.columnType=3;
            
        //    if(item.zcType=='WINBID'||item.zcType=='BID'){
        //     this.bidDetail=item;
        //    }else 
           if(item.zcType=='PURCHASE'||item.zcType=='WINBID'||item.zcType=='BID'){
            this.get(this.api.getZcxxOne,{id:item.id}).then(res=>{
                if(res.result==200){
                    this.bidDetail=res.data;
                }
            }).catch();
           }else{
            // this.get(this.api.getZcxxQxxxOne,{id:item.id}).then(res=>{
            //     if(res.result==200){
            //         this.bidDetail.titleName=res.data.titleName;
            //         this.bidDetail.createDate=res.data.createDate;
            //         this.bidDetail.publishPerson=res.data.publishPerson;
            //         this.bidDetail.content=res.data.purpose;
            //     }
            // }).catch();
                this.currentColumn='器械招商';
                this.chatId=item.id;
                this.columnType=2;
                this.get(this.api.getZcxxQxxxOne,{id:item.id}).then(res=>{
                    if(res.result==200){
                        
                        this.qxDetail=res.data;
                    }
                }).catch();
           }
            
            
        },
        getQXZSByCode(code){
            this.deviceTypeCode=code;
            this.getQxzsPage();
        },
        changePage1 (val, type) {
            if (type) {
                this.page.targetPage = 1;
                this.page.pageSize = val;
            } else {
                this.page.targetPage = val;
            }
            this.pageZczxPage();
        },
        changePage2 (val, type) {
            if (type) {
                this.page.targetPage = 1;
                this.page.pageSize = val;
            } else {
                this.page.targetPage = val;
            }
            this.getQxzsPage();
        },
    }
}